// src/beta/services/showcase.ts
import { betaFetch } from '@/beta/services/api';
import type { ShowcaseBundle, V1Envelope } from '@/beta/types/showcase';

interface GetShowcaseBundleOptions {
  signal?: AbortSignal;
}

/** Fetches the focus bundle for one vehicle. One round-trip — backend
 *  aggregates phases, components, provenance, documents, verification,
 *  matching components, attributions, stories metadata, anchor, and counts.
 *  Auth token is injected by `betaFetch` via the shared `getAuthToken` helper. */
export async function getShowcaseBundle(
  vehicleId: string,
  opts: GetShowcaseBundleOptions = {},
): Promise<ShowcaseBundle> {
  const envelope = await betaFetch<V1Envelope<ShowcaseBundle>>(
    `/vehicles/${encodeURIComponent(vehicleId)}/showcase?bundle=focus`,
    { signal: opts.signal },
  );

  if (envelope.version !== 1) {
    throw new Error(`Unexpected envelope version: ${envelope.version}`);
  }

  return envelope.data;
}
